module.exports = __webpack_public_path__ + "static/instaa-logo-new-0eda0fea5cca43bfa16ba618a05cbddd.png";